import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'ramda';
import Checkbox from 'components/Checkbox';
import { th } from 'style/theme';
import VeryHappy from 'products/nomad_insurance/assets/img/nps/very_happy.png';
import Happy from 'products/nomad_insurance/assets/img/nps/happy.png';
import Disappointed from 'products/nomad_insurance/assets/img/nps/disappointed.png';
import {
  RatingContainer,
  SubHeading,
  RatingSelection,
  HelpTexts,
  RadioButton,
  Why,
  TextArea,
  NextButton,
  SmallTextArea
} from './styled';

const Rating = ({
  productTitle,
  onNextClick,
  onSubmit,
  onRatingChange,
  rating,
  onFeedbackChange,
  feedback,
  onHearAboutUsChange,
  campaign,
  hearAboutUs
}) => {
  const getColor = (i) => {
    if (i <= 5) {
      return th('colors.red');
    }
    if (i <= 7) {
      return th('colors.yellow');
    }
    return '#6CF085';
  };

  const getImage = (i) => {
    if (i <= 5) {
      return Disappointed;
    }
    if (i <= 7) {
      return Happy;
    }
    return VeryHappy;
  };

  return (
    <RatingContainer>
      <SubHeading>How likely are you to recommend {productTitle} to a friend?</SubHeading>
      <RatingSelection>
        <HelpTexts>
          <div>Unlikely</div>
          <div>Very likely</div>
        </HelpTexts>
        {range(1, 11).map((i) => (
          <RadioButton
            key={i}
            name="nps"
            type="radio"
            value={i}
            checked={Number(rating) === i}
            $color={getColor(i)}
            $image={getImage(i)}
            onChange={(e) => onRatingChange(e.target.value)}
          />
        ))}
      </RatingSelection>
      <Checkbox
        name="no-opinion"
        onChange={() => onRatingChange(undefined)}
        checked={typeof rating === 'undefined'}
      >
        No opinion
      </Checkbox>
      <Why>
        <SubHeading>Why?</SubHeading>
        <TextArea onChange={onFeedbackChange} value={feedback} />
      </Why>
      {campaign !== 'claims_ni' && (
        <Why>
          <SubHeading>Where did you hear about us?</SubHeading>
          <SmallTextArea onChange={onHearAboutUsChange} value={hearAboutUs} />
        </Why>
      )}
      {rating >= 8 ? (
        <NextButton onClick={onNextClick}>Next</NextButton>
      ) : (
        <NextButton onClick={onSubmit}>Submit</NextButton>
      )}
    </RatingContainer>
  );
};

Rating.propTypes = {
  productTitle: PropTypes.string.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onRatingChange: PropTypes.func.isRequired,
  onFeedbackChange: PropTypes.func.isRequired,
  onHearAboutUsChange: PropTypes.func.isRequired,
  rating: PropTypes.number,
  feedback: PropTypes.string,
  hearAboutUs: PropTypes.string,
  campaign: PropTypes.string
};

export default Rating;
